import { render, staticRenderFns } from "./VChartHeader.vue?vue&type=template&id=33506932&"
import script from "./VChartHeader.vue?vue&type=script&lang=ts&"
export * from "./VChartHeader.vue?vue&type=script&lang=ts&"
import style0 from "./VChartHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports